import { useCallback } from 'react';
import { Button, Heading, Layout, SimpleModal, Text } from '../core';

type SessionExpiryModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onLogoutNow: () => Promise<void>;
};

export const SessionExpiryModal = ({
  isOpen,
  onClose,
  onLogoutNow,
}: SessionExpiryModalProps): JSX.Element | null => {
  const handleLogoutNow = useCallback(async () => {
    await onLogoutNow();
  }, [onLogoutNow]);

  const headerId = 'session-expiry-modal-header';

  if (!isOpen) {
    return null;
  }

  return (
    <SimpleModal headerId={headerId} onClose={onClose} size="sm">
      <Layout.VStack space={6} paddingTop={8} paddingBottom={6}>
        <Layout.VStack space={2}>
          <Heading.h4 id={headerId} level={2}>
            Your session will expire soon.
          </Heading.h4>

          <Text.para>
            For your privacy, you will be logged out within the next 3 minutes and be prompted to
            log back in to protect your account.
          </Text.para>

          <Text.para>
            If you're completing a form or message, it will not be saved. We recommend logging out
            now and logging back in to start a new session.
          </Text.para>
        </Layout.VStack>

        <Layout.VStack space={4} paddingTop={4} paddingBottom={2}>
          <Button.secondaryMedium testID="button-logout-now" onPress={handleLogoutNow}>
            Log out now
          </Button.secondaryMedium>
        </Layout.VStack>
      </Layout.VStack>
    </SimpleModal>
  );
};
